import { DefaultScrollBar } from "@/components/scrollbar/DefaultScrollBar/DefaultScrollBar";
import { useFocusAtEnd } from "@/hooks/useFocusAtEnd";

import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import styles from "./TextAreaWithScrollBar.module.css";

interface Props {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  placeholder?: string;
  backValue: (e: string) => void;
}

export const TextAreaWithScrollBar = ({ children, style, placeholder, backValue, ...props }: Props) => {
  const focusAtEnd = useFocusAtEnd();
  const ref = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const savedRange = useRef<Range | null>(null);
  const [viewPlaceholder, setViewPlaceholder] = useState(true);

  useEffect(() => {
    if (ref.current && children) {
      ref.current.innerText = children as string;
    }
  }, []);

  //eslint-disable-next-line
  const onFocus = (e: any) => {
    focusAtEnd(e.currentTarget);
  };

  const handleBlur = () => {
    const sel = window.getSelection();
    if (sel?.rangeCount) {
      savedRange.current = sel.getRangeAt(0).cloneRange();
    }
  };

  //eslint-disable-next-line
  const handleChange = (e: any) => {
    const text = e.target.innerText.replace(/\n{2,}/g, "\n").trimEnd();
    backValue(text);
    setViewPlaceholder(!text.replace(/\n/g, ""));
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
  };

  return (
    <div ref={containerRef} className={styles.textareaOverlay} {...props} style={style}>
      {placeholder && viewPlaceholder && <span className={styles.placeholder}>{placeholder}</span>}
      <div
        ref={ref}
        onFocus={onFocus}
        onBlur={handleBlur}
        className={clsx(styles.textarea)}
        contentEditable
        suppressContentEditableWarning={true}
        onInput={handleChange}
        onPaste={handlePaste}
      />

      <DefaultScrollBar
        sizeHeight={94}
        scrollBar={{ width: 6, positionMode: "over" }}
        track={{
          style: {
            borderRadius: "8px",
            backgroundColor: "transparent",
          },
        }}
        thumb={{
          width: 4,
          style: {
            borderRadius: "8px",
            backgroundColor: "rgba(255, 255, 255, .2)",
          },
          boxShadowOnHover: "none",
        }}
      />
    </div>
  );
};
